<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <!-- // 代号 20241212-1  整页-->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-hang v-if="isPanelExtension" @click.native="deviceSet('panelExtensionManage')">
        <span slot="config_hang_ele2">扩展面板管理</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang @click.native="deviceSet('changeRemark')">
        <span slot="config_hang_ele2">修改设备备注</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang v-if="query.type == 'offLine'" @click.native="deviceSet('replace')">
        <span slot="config_hang_ele2">替换设备</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang v-if="query.type == 'onLine'" @click.native="deviceSet('changeAddress')">
        <span slot="config_hang_ele2">修改设备地址</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: [],
        threadNewProductList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      query: {}
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    deviceSet(type) {
      if (type == 'panelExtensionManage') {
        this.getPanelExtensionThirdPanelList();
        return;
      }
      this.query.type = this.query.type + type;
      console.log("改变设备地址或备注!" + this.query.type);
      if (type == 'replace') {
        this.$router.push({
          path: "addNewDevice",
          query: this.query
        });
      } else {
        console.log(this.query);
        this.$router.push({
          path: "addNewDevice",
          query: this.query
        });
      }

    },
    getPanelExtensionThirdPanelList() {
      this.$request({
        method: "post",
        url: "/panelExtension/findThirdPanelListByExtensionId",
        // 后端此接口最大超时经过计算为60*100+3000 = 9000ms 详见后端代码 serverWaitTime
        timeout: 11000,
        data: {
          token: this.$store.state.token,
          extensionProductId: this.query.productId,
          state: this.query.type === "onLine" ? 1 : 0
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            let data = res.data.data;
            this.$store.dispatch(
              "asyUpdataPanelExtensionThirdPanelListData",
              this.formatPanelExtensionThirdPanelListData(data)
            );
            this.$router.push({
              path: "panelExtensionManage",
              query: this.query
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatPanelExtensionThirdPanelListData(data) {
      return {
        extensionProductId: this.query.productId,
        offLineList: data.offLineList || [],
        onLineList: data.onLineList || [],
        capacityTotal: data.capacityTotal || 0,
        capacityUsed: data.capacityUsed || 0,
        capacityRemain: data.capacityRemain || 0,
        errorMsg: data.errorMsg || ""
      };
    }

  },
  computed: {
    isPanelExtension() {
      return this.query.productCode === '100' && Number(this.query.productSource) === 1;
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.query);
    console.log(this.oneHostData);
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
